/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { SocialSharePopup } from "../../Atoms/SocialSharePopup";
import "./social-share-template.m.css";
import { Twitter } from "../../Svgs/SocialIcons/twitter";
import { Facebook } from "../../Svgs/SocialIcons/facebook";
import { LinkedIn } from "../../Svgs/SocialIcons/linkedin";
import { WhatsApp } from "../../Svgs/SocialIcons/whatsapp";
import { CloseIcon } from "../../Svgs/close-icon";
import { ShareIcon } from "../../Svgs/share-icon";
import { clientWidth } from "../../../utils/utils";

const ShareItem = ({ name, url, icon, dataTestId }) => {
  return (
    <li data-testid={dataTestId} styleName="icon">
      <a href={url} target="_blank" rel="noopener noreferrer" data-share-icon={name}>
        {icon}
      </a>
    </li>
  );
};
ShareItem.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.node,
  dataTestId: PropTypes.string
};
function getSocialShareData({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl }) {
  const grey = "#333333";
  return [
    {
      name: "facebook",
      url: fbUrl,
      icon: <Facebook color={grey} />
    },
    {
      name: "twitter",
      url: twitterUrl,
      icon: <Twitter color={grey} />
    },
    {
      name: "linkedin",
      url: linkedinUrl,
      icon: <LinkedIn color={grey} />
    },
    {
      name: "whatsapp",
      url: whatsappUrl,
      icon: <WhatsApp color={grey} />
    }
  ];
}

function getActionIcon(open) {
  if (!open) return <ShareIcon />;
  return <CloseIcon />;
}

export const SocialShareTemplate = ({ fbUrl = "", twitterUrl = "", linkedinUrl = "", whatsappUrl = "" }) => {
  const options = {
    fbUrl,
    twitterUrl,
    linkedinUrl,
    whatsappUrl
  };
  const iconsList = getSocialShareData(options);
  const [isOpen, setIsOpen] = useState(false);
  const [expand, setExpand] = useState(false);
  const notDesktop = clientWidth("mobile") || clientWidth("tablet");
  const renderClasses = clientWidth("mobile") ? "popup-wrapper" : "tablet-view";

  const shareHandler = () => {
    if (expand) {
      setExpand(false);
    } else {
      notDesktop ? setIsOpen(true) : setExpand(true);
    }
  };
  return (
    <div styleName={`${clientWidth("tablet") ? "share-wrapper" : ""}`}>
      <ul styleName={`wrapper  ${expand ? "open" : ""}`}>
        <li styleName="icon" key="horizontal-0">
          <div onClick={shareHandler}>{getActionIcon(expand)}</div>
        </li>

        {!notDesktop &&
          iconsList.map((iconData, index) => (
            <ShareItem {...iconData} key={iconData.name} dataTestId={`card-share-${index}`} />
          ))}
      </ul>
      {notDesktop && isOpen && (
        <div styleName="overlay">
          <div styleName={`${renderClasses} ${isOpen ? "popup-open" : "popup-close"}`}>
            <SocialSharePopup
              fbUrl={fbUrl}
              twitterUrl={twitterUrl}
              linkedinUrl={linkedinUrl}
              whatsappUrl={whatsappUrl}
              closePopup={() => {
                setIsOpen(false);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

SocialShareTemplate.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string
};
